/**
 * Mapbox GL JS v3's default ESM worker (import.meta.url / blob) breaks in
 * CRA production on Amplify: WebGL canvas stays a flat color, HTML markers still show.
 * Use the CSP build and a same-origin worker copied to /public.
 */
const loaded = require("mapbox-gl/dist/mapbox-gl-csp");
const mapboxgl = loaded.default || loaded;

mapboxgl.workerUrl = `${process.env.PUBLIC_URL || ""}/mapbox-gl-csp-worker.js`;

try {
  const status = mapboxgl.getRTLTextPluginStatus?.();
  if (status !== "loaded" && status !== "loading") {
    mapboxgl.setRTLTextPlugin(
      "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
      null,
      true
    );
  }
} catch (_) {
  // Plugin already registered / unavailable.
}

export default mapboxgl;
